<template>
  <div class="flex flex-col p-6 ml-4 lg:ml-64">
    <h2 class="text-xl text-gray-900 font-semibold mb-4">
      Cadastro de Empresas e Funcionários
    </h2>
    <!-- Campo de busca -->
    <div class="mb-6">
      <h3 class="text-lg font-semibold">Empresas</h3>
      <ul class="border rounded p-4 bg-white">
        <div class="py-2 flex items-center justify-between">
          <input
            type="text"
            v-model="searchQuery"
            class="p-2 border border-gray-300 rounded"
            placeholder="Pesquisar (Nome, Segmento)..."
          />
        </div>

        <!-- Botões Adicionar Empresa -->
        <button
          class="btn-gray px-2 py-1 w-32 bg-blue-500 text-white rounded mb-4 text-xs"
          @click="openModal"
        >
          Adicionar Empresa
        </button>

        <!-- Tabela de listagem das empresas -->
        <table
          class="min-w-full table-auto border-collapse text-black text-xs border border-gray-300"
        >
          <thead>
            <tr>
              <th class="border px-4 py-2">ID</th>
              <th class="border px-4 py-2">Nome da Empresa</th>
              <th class="border px-4 py-2">Segmento</th>
              <th class="border px-4 py-2">Estado</th>
              <th class="border px-4 py-2">Cidade</th>
              <th class="border px-4 py-2">E-mail</th>
              <th class="border px-4 py-2">Telefone</th>
              <th class="border px-4 py-2">Endereço</th>
              <th class="border px-4 py-2">Site</th>
              <th class="border px-4 py-2">Responsável Preposto</th>
              <th class="border px-4 py-2">CNPJ</th>
              <th class="border px-4 py-2">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(enterprise, index) in filteredEnterprises"
              :key="enterprise._id"
            >
              <div
                v-if="modalFuncionarioAberto"
                class="modal-overlay fixed inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center"
              >
                <div
                  class="modal bg-white p-6 rounded shadow-lg w-full max-w-full h-full relative overflow-auto"
                >
                  <!-- Passando apenas ID e Nome da empresa para o AdminEmployees -->
                  <AdminEmployees
                    :EmpresaID="formData.EmpresaID"
                    :NomeDaEmpresa="formData.NomeEmpresa"
                  />
                </div>
              </div>

              <div
                v-if="modalControleAberto"
                class="modal-overlay fixed inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center"
              >
                <div
                  class="modal bg-white p-6 rounded shadow-lg w-full max-w-full h-full relative overflow-auto"
                >
                  <!-- Passando apenas ID e Nome da empresa para o AdminControle -->
                  <ControlManagement
                    :EmpresaID="formData.EmpresaID"
                    :NomeDaEmpresa="formData.NomeEmpresa"
                  />
                  <button
                    class="px-4 py-2 ml-100 bg-red-500 rounded hover:bg-amber-800"
                    @click="closedModalControle"
                  >
                    Fechar
                  </button>
                </div>
              </div>

              <td class="border px-4 py-2">{{ generateId(index) }}</td>
              <td class="border px-4 py-2 truncate w-16 max-w-[8rem]">
                {{ enterprise.NomeEmpresa }}
              </td>
              <td class="border px-4 py-2">{{ enterprise.Segmento }}</td>
              <td class="border px-4 py-2">{{ enterprise.Estado }}</td>
              <td class="border px-4 py-2 truncate">{{ enterprise.Cidade }}</td>
              <td class="border px-4 py-2 truncate w-16 max-w-[8rem]">
                {{ enterprise.Email }}
              </td>
              <td class="border px-4 py-2 truncate">
                {{ enterprise.Telefone }}
              </td>
              <td class="border px-4 py-2 truncate w-16 max-w-[8rem]">
                {{ enterprise.Endereco }}
              </td>
              <td class="border px-4 py-2 truncate w-16 max-w-[8rem]">
                {{ enterprise.Site }}
              </td>
              <td class="border px-4 py-2 truncate w-16 max-w-[8rem]">
                {{ enterprise.ResponsavelProposto }}
              </td>
              <td class="border px-4 py-2 truncate">{{ enterprise.CNPJ }}</td>
              <td class="border px-4 py-2">
                <div class="flex gap-2">
                  <button
                    class="px-2 py-1 rounded text-xs text-black"
                    @click="handleEdit(enterprise)"
                  >
                    ✏️ Editar
                  </button>
                  <button
                    class="px-2 py-1 rounded text-xs text-black"
                    @click="confirmarRemocao(enterprise._id)"
                  >
                    🗑️ Remover
                  </button>
                  <button
                    class="px-2 py-1 rounded text-xs text-black"
                    @click="
                      openModalFuncionario(
                        enterprise._id,
                        enterprise.NomeEmpresa
                      )
                    "
                  >
                    👨‍👨 Funcionário
                  </button>
                  <button
                    class="px-2 py-1 rounded text-xs text-black"
                    @click="
                      openModalControle(enterprise._id, enterprise.NomeEmpresa)
                    "
                  >
                    📝 Controle
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </ul>
    </div>

    <!-- Modal de Cadastro/Edição -->
    <div
      v-if="modalAberto"
      class="modal-overlay fixed inset-0 bg-gray-500 bg-opaCidade-50 flex items-center justify-center ml-70"
    >
      <div
        class="modal bg-white p-6 rounded shadow-lg w-[100%] max-w-4xl h-[100%] relative overflow-auto"
      >
        <button
          class="px-4 py-2 bg-red-500 rounded hover:bg-amber-800"
          @click="closedModal"
        >
          Fechar
        </button>
        <h2 class="text-2xl font-semibold mb-4">
          {{ isEditing ? 'Editar Empresa' : 'Nova Empresa' }}
        </h2>
        <form @submit.prevent="handleSubmit">
          <label class="block text-sm font-medium">Nome da empresa</label>
          <textarea
            v-model="formData.NomeEmpresa"
            class="w-full p-2 border border-gray-300 rounded mb-4 resize-none"
            required
            :style="{
              minWidth: '750px',
              maxWidth: '100%',
              overflowWrap: 'break-word',
              whiteSpace: 'pre-wrap',
              height: 'auto',
            }"
            rows="1"
            @input="handleInput"
          ></textarea>

          <label class="block text-sm font-medium">Segmento</label>
          <textarea
            v-model="formData.Segmento"
            class="w-full p-2 border border-gray-300 rounded mb-4 resize-none"
            required
            :style="{
              minWidth: '750px',
              maxWidth: '100%',
              overflowWrap: 'break-word',
              whiteSpace: 'pre-wrap',
              height: 'auto',
            }"
            rows="1"
            @input="adjustHeight($event)"
          ></textarea>

          <label class="block text-sm font-medium">Estado</label>
          <textarea
            v-model="formData.Estado"
            class="w-full p-2 border border-gray-300 rounded mb-4 resize-none"
            required
            :style="{
              minWidth: '750px',
              maxWidth: '100%',
              overflowWrap: 'break-word',
              whiteSpace: 'pre-wrap',
              height: 'auto',
            }"
            rows="1"
            @input="adjustHeight($event)"
          ></textarea>

          <label class="block text-sm font-medium">Cidade</label>
          <textarea
            v-model="formData.Cidade"
            class="w-full p-2 border border-gray-300 rounded mb-4 resize-none"
            required
            :style="{
              minWidth: '750px',
              maxWidth: '100%',
              overflowWrap: 'break-word',
              whiteSpace: 'pre-wrap',
              height: 'auto',
            }"
            rows="1"
            @input="adjustHeight($event)"
          ></textarea>

          <label class="block text-sm font-medium">E-mail</label>
          <input
            v-model="formData.Email"
            type="Email"
            class="w-full p-2 border border-gray-300 rounded mb-4"
            required
            :style="{
              minWidth: '750px',
              maxWidth: '100%',
              overflowWrap: 'break-word',
              whiteSpace: 'pre-wrap',
              height: 'auto',
            }"
            @input="adjustHeight($event)"
          />

          <label class="block text-sm font-medium">Telefone</label>
          <input
            v-model="formData.Telefone"
            type="tel"
            class="w-full p-2 border border-gray-300 rounded mb-4"
            required
            :style="{
              minWidth: '750px',
              maxWidth: '100%',
              overflowWrap: 'break-word',
              whiteSpace: 'pre-wrap',
              height: 'auto',
            }"
            @input="handlePhoneInput($event)"
          />

          <label class="block text-sm font-medium">Endereço</label>
          <textarea
            v-model="formData.Endereco"
            class="w-full p-2 border border-gray-300 rounded mb-4 resize-none"
            required
            :style="{
              minWidth: '750px',
              maxWidth: '100%',
              overflowWrap: 'break-word',
              whiteSpace: 'pre-wrap',
              height: 'auto',
            }"
            rows="1"
            @input="adjustHeight($event)"
          ></textarea>
          <label class="block text-sm font-medium">Site</label>
          <textarea
            v-model="formData.Site"
            class="w-full p-2 border border-gray-300 rounded mb-4 resize-none"
            required
            :style="{
              minWidth: '750px',
              maxWidth: '100%',
              overflowWrap: 'break-word',
              whiteSpace: 'pre-wrap',
              height: 'auto',
            }"
            rows="1"
            @input="adjustHeight($event)"
          ></textarea>
          <label class="block text-sm font-medium">Responsável Preposto</label>
          <textarea
            v-model="formData.ResponsavelProposto"
            class="w-full p-2 border border-gray-300 rounded mb-4 resize-none"
            required
            :style="{
              minWidth: '750px',
              maxWidth: '100%',
              overflowWrap: 'break-word',
              whiteSpace: 'pre-wrap',
              height: 'auto',
            }"
            rows="1"
            @input="adjustHeight($event)"
          ></textarea>

          <label class="block text-sm font-medium">CNPJ</label>
          <input
            v-model="formData.CNPJ"
            type="text"
            class="w-full p-2 border border-gray-300 rounded mb-4"
            required
            :style="{
              minWidth: '750px',
              maxWidth: '100%',
              overflowWrap: 'break-word',
              whiteSpace: 'pre-wrap',
              height: 'auto',
            }"
            @input="handleCNPJInput($event)"
          />
          <p v-if="cnpjErro" class="text-red-500 text-sm mt-1">
            {{ cnpjErro }}
          </p>

          <div class="modal-footer flex justify-end mt-4">
            <button
              type="submit"
              class="btn-success bg-blue-500 text-white py-2 px-4 rounded mr-0.5"
            >
              Salvar
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import ControlManagement from '@/components/dashboard/controller/AssignControlManagement.vue'
import AdminEmployees from '@/components/dashboard/employee/Employees.vue'
import {
  createEnterprise,
  deleteEnterprise,
  getEnterprises,
  updateEnterprise,
} from '@/services/company/api.enterprise'
export default {
  components: {
    AdminEmployees,
    ControlManagement,
  },
  data() {
    return {
      enterprises: [],
      modalAberto: false,
      modalControleAberto: false,
      modalFuncionarioAberto: false,
      selectedEnterprise: {},
      formData: {
        NomeEmpresa: '',
        Segmento: '',
        Estado: '',
        Cidade: '',
        Email: '',
        Telefone: '',
        Endereco: '',
        Site: '',
        ResponsavelProposto: '',
        CNPJ: '',
      },
      isEditing: false,
      modalAberto: false,
      searchQuery: '',
    }
  },
  computed: {
    filteredEnterprises() {
      return this.enterprises.filter((enterprise) => {
        const query = this.searchQuery.toLowerCase()
        return (
          enterprise.NomeEmpresa.toLowerCase().includes(query) ||
          enterprise.Segmento.toLowerCase().includes(query) ||
          enterprise.CNPJ.toLowerCase().includes(query)
        )
      })
    },
  },
  methods: {
    generateId(index) {
      return `${index + 1}`
    },

    handlePhoneInput(event) {
      this.formatPhone(event)
      this.adjustHeight(event)
    },

    handleInput(event) {
      this.formData.NomeEmpresa = event.target.value.toUpperCase()
      this.adjustHeight(event)
    },
    handleCNPJInput(event) {
      this.formatCNPJ(event)
      this.adjustHeight(event)
    },

    formatPhone(event) {
      let value = event.target.value.replace(/\D/g, '')

      if (value.length > 11) {
        value = value.substring(0, 11)
      }

      if (value.length >= 2) {
        value = `(${value.substring(0, 2)}) ${value.substring(2)}`
      }
      if (value.length >= 10) {
        value = `${value.substring(0, 10)}-${value.substring(10)}`
      }

      this.formData.Telefone = value
    },

    formatCNPJ(event) {
      let value = event.target.value.replace(/\D/g, '')

      if (value.length > 14) {
        value = value.substring(0, 14)
      }

      if (value.length >= 3) {
        value = `${value.substring(0, 2)}.${value.substring(2)}`
      }
      if (value.length >= 7) {
        value = `${value.substring(0, 6)}.${value.substring(6)}`
      }
      if (value.length >= 11) {
        value = `${value.substring(0, 10)}/${value.substring(10)}`
      }
      if (value.length >= 16) {
        value = `${value.substring(0, 15)}-${value.substring(15)}`
      }

      this.formData.CNPJ = value
    },

    openModalFuncionario(EmpresaIdF, NomeEmpresa) {
      this.formData.NomeEmpresa = NomeEmpresa
      this.formData.EmpresaID = EmpresaIdF.toString()

      this.modalFuncionarioAberto = true
    },
    openModalControle(EmpresaIdC, NomeEmpresa) {
      this.formData.NomeEmpresa = NomeEmpresa
      this.formData.EmpresaID = EmpresaIdC.toString()

      this.modalControleAberto = true
    },

    closedModalFuncionario() {
      this.modalFuncionarioAberto = false
    },

    closedModalControle() {
      this.modalControleAberto = false
    },

    adjustHeight(event) {
      const textarea = event.target
      textarea.style.height = 'auto'
      textarea.style.height = textarea.scrollHeight + 'px'
    },

    async loadEnterprises() {
      try {
        const data = await getEnterprises()
        this.enterprises = data.sort((a, b) => a.EmpresaID - b.EmpresaID)
      } catch (error) {
        console.error('Erro ao carregar empresas:', error)
      }
    },

    openModal() {
      this.modalAberto = true
      this.isEditing = false
      this.formData = {
        NomeEmpresa: '',
        Segmento: '',
        Estado: '',
        Cidade: '',
        Email: '',
        Telefone: '',
        Endereco: '',
        Site: '',
        ResponsavelProposto: '',
        CNPJ: '',
      }
    },

    closedModal() {
      this.modalAberto = false
    },

    async handleSubmit() {
      try {
        if (this.isEditing) {
          await updateEnterprise(this.formData._id, this.formData)
        } else {
          await createEnterprise(this.formData)
        }
        await this.loadEnterprises()
        this.closedModal()
      } catch (error) {
        console.error('Erro ao salvar empresa:', error)
      }
    },

    handleEdit(enterprise) {
      this.formData = { ...enterprise }
      this.isEditing = true
      this.modalAberto = true
    },

    async confirmarRemocao(id) {
      const confirmacao = confirm(
        'Tem certeza que deseja remover esta empresa?'
      )
      if (confirmacao) {
        try {
          await deleteEnterprise(id)
          await this.loadEnterprises()
        } catch (error) {
          console.error('Erro ao remover empresa:', error)
        }
      }
    },
  },
  created() {
    this.loadEnterprises()
  },
}
</script>
